const departments = {
    leader: '책임자',
    leaders: '부서 책임자',
    led_departments: '담당 부서',
    edit_leaders: '책임자 관리',
    add_leader: '추가',
    remove_leader: '제거',
    no_leaders: '책임자 없음',
    local: '로컬 관리',
    managed_members: '관리 범위의 구성원',
    leader_scope_hint: '담당 부서와 하위 부서의 소속을 관리합니다.',
    leader_permission_hint: '책임자는 담당 부서와 하위 부서의 소속을 관리하며 조직 역할이나 부서 구조를 변경할 수 없습니다.',
    primary_synced: '주 부서는 Feishu에서 관리합니다.',
    status_active: '재직',
    status_suspended: '정지됨',
    status_departed: '퇴사',
    status_pending: '활성화 대기',
    search: '검색',
    previous_page: '이전 페이지',
    next_page: '다음 페이지',
    directory_title: '조직 구성원',
    member_name: '구성원',
    search_members: '이름 또는 사용자 이름으로 검색',
    include_descendants: '하위 부서 포함',
    no_members: '일치하는 구성원이 없습니다.',
    all_members: '모든 구성원',
    all_departments: '모든 부서',
    edit_member: '소속 부서 편집',
    add_child: '하위 부서 추가',
    expand_department: '{{name}} 펼치기',
    collapse_department: '{{name}} 접기',
    title: '부서',
    description: '이 조직의 부서와 구성원 소속을 관리합니다.',
    create: '부서 만들기',
    edit: '부서 편집',
    name: '부서 이름',
    parent: '상위 부서',
    root: '상위 부서 없음',
    id: '부서 ID',
    members: '구성원 부서',
    member_id: '구성원 사용자 ID',
    primary: '주 부서',
    none: '설정 안 됨',
    assignments: '부서 소속 기록',
    no_assignments: '아직 부서 소속 기록이 없습니다.',
    assignment_hint: '로컬 부서와 선택적으로 주 부서를 지정합니다. 디렉터리 소속은 읽기 전용입니다.',
    empty: '아직 부서가 없습니다.',
    readonly: '부서와 내 소속을 확인할 수 있습니다. 변경하려면 조직 관리자에게 문의하세요.',
    load_error: '데이터를 불러올 수 없습니다. 다시 시도하세요.',
    mutation_error: '저장할 수 없습니다. 권한, 조직 소속 및 부서 계층을 확인하세요.',
    loading: '불러오는 중…',
    synced: '디렉터리 관리',
    choose: '부서 검색',
    organizations_title: '조직 및 부서',
    organizations_description: '조직을 선택하여 부서를 보거나 관리하세요.',
    no_organizations: '가입한 조직이 없습니다. 조직 관리자에게 문의하세요.',
    organization: '현재 조직',
    choose_organization: '조직 선택',
    delete_title: '부서 삭제',
    delete_description: '“{{name}}” 부서를 삭제할까요? 먼저 구성원과 하위 부서를 이동하세요.',
};
export default Object.freeze(departments);
